import React from 'react';
import { MessageSquare, Zap, Clock, ArrowRight } from 'lucide-react';

const BobetteSection = () => {
  return (
    <section className="py-16 px-6 bg-gradient-to-r from-noordblue-light to-white">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Content */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <MessageSquare className="h-8 w-8 text-noordblue" />
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  Maak kennis met Bobbette
                </h2>
              </div>
              
              <p className="text-xl text-gray-700 mb-6">
                Onze slimme OpenAI agent die automatisch maatwerk offertes genereert op basis van 
                realistische tijdsinschattingen. Transparant €110/uur tarief.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <Zap className="h-6 w-6 text-noordblue shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900">AI-gestuurde tijdsinschattingen</h3>
                    <p className="text-gray-600">Realistische uurschattingen op basis van OpenAI expertise</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <Clock className="h-6 w-6 text-noordblue shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Transparante pricing</h3>
                    <p className="text-gray-600">€110/uur excl. BTW + minimum 3 uur basisopstelling (€330)</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <MessageSquare className="h-6 w-6 text-noordblue shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Maatwerk offertes</h3>
                    <p className="text-gray-600">Geen vaste categorieën, elke offerte is uniek en gedetailleerd</p>
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://bobbette.noord-ai.nl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-noordblue hover:bg-noordblue-dark text-white px-6 py-3 rounded-lg font-medium transition-colors"
                >
                  Probeer Bobbette
                  <ArrowRight className="h-4 w-4" />
                </a>
                
                <a
                  href="/blog/maak-kennis-met-bobbette"
                  className="inline-flex items-center justify-center gap-2 border border-noordblue text-noordblue hover:bg-noordblue hover:text-white px-6 py-3 rounded-lg font-medium transition-colors"
                >
                  Lees meer
                </a>
              </div>
            </div>
            
            {/* Visual/Demo */}
            <div className="relative">
              <div className="bg-white rounded-lg shadow-xl p-6 max-w-md mx-auto">
                <div className="flex items-center gap-2 mb-4 pb-4 border-b">
                  <div className="w-8 h-8 bg-noordblue rounded-full flex items-center justify-center">
                    <MessageSquare className="h-4 w-4 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Bobbette</h4>
                    <p className="text-sm text-green-500">● Online</p>
                  </div>
                </div>
                
                <div className="space-y-3">
                  <div className="bg-gray-100 rounded-lg p-3">
                    <p className="text-sm text-gray-700">
                      Hoi! Ik ben Bobbette, jouw slimme OpenAI agent. Ik maak maatwerk offertes 
                      op basis van €110/uur. Vertel me over je project!
                    </p>
                  </div>
                  
                  <div className="bg-noordblue text-white rounded-lg p-3 ml-8">
                    <p className="text-sm">
                      Ik wil graag een e-commerce website met betalingen
                    </p>
                  </div>
                  
                  <div className="bg-gray-100 rounded-lg p-3">
                    <p className="text-sm text-gray-700">
                      Perfect! Ik schat ongeveer 40 uur voor een complete e-commerce oplossing. 
                      Dat wordt €4.400 excl. BTW. Welke functionaliteiten zijn het belangrijkst?
                    </p>
                  </div>
                  
                  <div className="flex items-center justify-center py-2">
                    <div className="flex space-x-1">
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse"></div>
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                      <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                €110/uur
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-blue-100 text-noordblue px-3 py-1 rounded-full text-sm font-medium">
                OpenAI Powered
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BobetteSection;